import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import RoleUtils from '../utils/roleUtils.js';
import { Link } from 'react-router-dom';
import CommonUtils from '../utils/siteUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import RequestUtils from "../utils/requestUtils";
import { Loading } from '../components/Loading';
import { VendorBankPopUp } from '../components/VendorBankPopUp';
import '../styles/Vendor.css';

export class VendorTable extends Component {
    constructor(props) {
        super()
        this.getVendorInfo = this.getVendorInfo.bind(this);
        this.updateVendorInfo = this.updateVendorInfo.bind(this);
        this.state = {
            vendorData: {},
            isLoading: true
        }
    }

    //Get supplier info and populate table on mount
    componentDidMount() {
        const currentBank = (this.props.editMode === "ADD")
            ? {}
            : this.props.vendorData.vendorBanks.filter(b => b.effStatus === 'A');

        this.setState({
            isLoading: false,
            vendorData: this.props.vendorData,
            currentBank: currentBank
        })

    }

    //Get supplier info and proper table when companyId changes
    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.vendorData) !== JSON.stringify(this.props.vendorData)) {
            const currentBank = (this.props.editMode === "ADD")
                ? {}
                : this.props.vendorData.vendorBanks.filter(b => b.effStatus === 'A');

            this.setState({
                isLoading: false,
                vendorData: this.props.vendorData,
                currentBank: currentBank
            })
        }
    }

    //Get supplier info for table
    getVendorInfo() {
        const { currentCompanyId } = this.props;
        this.setState({ vendorData: {}, isLoading: true });
        ServiceCalls.getVendorInfo(currentCompanyId).then(function (data) {
            if (data) {
                this.setState({ vendorData: data, isLoading: false });
            }
            else {
                //update not successful. - need to handle
                this.setState({ isLoading: false });
            }
        }.bind(this));
    }

    //Update supplier status in DB based on dropdown change
    updateVendorInfo() {
        const { currentCompanyId } = this.props;
        this.setState({ isLoading: true });
        ServiceCalls.updateVendor(currentCompanyId).then(function (data) {
            if (data) {
                this.setState({ vendorData: data, isLoading: false });
            }
            else {
                //update not successful. - need to handle
                this.setState({ isLoading: false });
            }
        }.bind(this));
    }

    // Format bank address for table display
    formatAddress() {
        const { vendorData } = this.state;
        var approvedReqs = vendorData.requests.filter(r => r.requestStatusId === 2);
        if (approvedReqs.length > 0) {
            //Reverse Sort Bank Address by Updated Dt
            var request = approvedReqs.sort(function (a, b) { return new Date(b.updatedDt) - new Date(a.updatedDt) })[0];
            if ((request.bankAddress.length === 0 && request.bankCity.length === 0 && request.bankState.length === 0 && request.bankPostal.length === 0) ||
                RequestUtils.maskString(request.requestBank.bankAccountNumber) !== RequestUtils.maskString(vendorData.vendorBanks[0].bankAccountNumber) ||
                request.requestBank.dfiNumber !== vendorData.vendorBanks[0].dfiNumber){
                return (<Col sm={3}></Col>);
            }          
            else {
                return (
                    <Col sm={3}>
                        <Row>
                            <Col sm={2}>
                                <div className='tableHeader'>Address</div>
                            </Col>
                            <Col>
                                <div>{request.bankAddress}</div>
                                <div>{`${request.bankCity}, ${request.bankState} ${request.bankPostal}`}</div>
                                <div>USA</div>
                            </Col>
                        </Row>
                    </Col>
                );//HARD CODE USA FOR NOW
            }
        }
        return (<Col sm={3}></Col>);
    }

    buildTable() {
        const { vendorData } = this.state;
        const { currentUser, currentCompanyId, showAll } = this.props;
        var canView = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.uhgRolesOnly());
        var canViewRO = RoleUtils.canAccess(currentUser, currentCompanyId, ["SP_Inquiry"]);
        var noBankView = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.profileEditNoBankRoles());
        var canEditBank = (this.props.vendorData.enabled) && (RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.profileEditBankRoles()));
        var currentPaymentMethod = vendorData.vendorPayments.length > 0 ? vendorData.vendorPayments[0].paymentMethod : '';
        //var currentBank = vendorData.vendorBanks.find(b => b.effStatus === "A");
        //Pending Request are not Approved,Rejected, Auto-Closed or Cancelled
        var pendingReqs = vendorData.requests.filter(r => r.requestStatusId !== 2 && r.requestStatusId !== 5 && r.requestStatusId !== 6 && r.requestStatusId !== 7);
        var approvedReqs = vendorData.requests.filter(r => r.requestStatusId === 2);
        //US6815746 - check if there is a recently approved (60 min) bank request
        var hasRecentApprovedReqs = approvedReqs.length > 0 ?
            approvedReqs.filter(function (item) {              
                return CommonUtils.determineIfTimeWithinRange(item.updatedDt, 60);
            }).length > 0
            : false;
        var bankEditButtonColSpace = (hasRecentApprovedReqs) ? 3 : 2;
        var bankEditSpace = (hasRecentApprovedReqs) ? 7 : 8;
        var canViewBank = canEditBank && ((currentPaymentMethod === "ACH" || currentPaymentMethod === "WIR") || (currentPaymentMethod === "CHK" && pendingReqs.length > 0)); // && vendorData.vendorBanks.length > 0;
        var showAddBank = canEditBank && currentPaymentMethod === "CHK" && pendingReqs.length === 0;
        //US7579497 - EMEA+ View - Banking
        var isEMEASupplier = CommonUtils.determineIfVendorIsEMEAPlus(vendorData);
        //Assume first pending request
        var path = (pendingReqs.length > 0) ? `/Worklist/Request/${pendingReqs[0].vendorBankRequestId}` : "";
        var requestMsg = (pendingReqs.length > 0 && ((canViewRO === false) || ((canViewRO === true || noBankView === true) && canEditBank === true)))
            ? <div className="vendorRequestLink">
                Click here to view pending&nbsp;
                <Link to={path} title="View Request">
                    change request
                </Link>
            </div>
            : <></>;
        var uhgIdDisplay = (vendorData.vendorBanks.length > 0 && (currentPaymentMethod === "ACH" || currentPaymentMethod === "WIR"))
            ? <Col sm={3}>
                <div className="tableHeader">
                    Bank Name
                </div>
                <div>
                    {/* DE774753: Bank Account Number on Wrong Line 
                       
                    */}
                   {vendorData.vendorBanks[0].beneficiaryBank
                        ? (<div>
                            {vendorData.vendorBanks[0].beneficiaryBank}
                        </div>)
                        : (<br />)}
                </div>
                <div className="tableHeader">
                    {CommonUtils.determineVendorBankNumberLabel(vendorData.vendorBanks[0].country, currentPaymentMethod, vendorData.vendorBanks[0].dfiQualifier)}
                </div>
                <div>
                    {(vendorData.vendorBanks[0].bankAccountNumber)
                        ? (<div>
                            {vendorData.vendorBanks[0].bankAccountNumber}
                        </div>)
                        : (<br />)}
                </div>
                {(vendorData.vendorBanks[0].dfiQualifier)
                    ? <>
                        <div className="tableHeader">
                            {CommonUtils.determineVendorBankRoutingLabel(vendorData.vendorBanks[0].dfiQualifier)}
                        </div>
                        <div>
                            {(vendorData.vendorBanks[0].dfiNumber)
                                ? (<div>
                                    {vendorData.vendorBanks[0].dfiNumber}
                                </div>)
                                : (<br />)}
                        </div>
                    </>
                    : <div className="tableHeader">&nbsp;</div>
                }                
            </Col>
            : <></>;
        var emeaBankDetails = (isEMEASupplier && vendorData.vendorBanks.length > 0)
            ?<>
            <Col sm={3}>
                <div className="tableHeader">
                    Bank Country
                </div>
                <div>
                    {vendorData.vendorBanks[0].country
                        ? (<div>
                            {vendorData.vendorBanks[0].country}
                        </div>)
                        : (<br />)}
                </div>
                <div className="tableHeader">
                        {CommonUtils.determineVendorBankNumberLabel(vendorData.vendorBanks[0].country, currentPaymentMethod, vendorData.vendorBanks[0].dfiQualifier)}
                </div>
                <div>
                    {vendorData.vendorBanks[0].bankAccountNumber}
                </div>
                    {(vendorData.vendorBanks[0].dfiNumber)
                        ? <>
                            <div className="tableHeader">
                                {CommonUtils.determineEMEAVendorBankRoutingLabel(vendorData.vendorBanks[0].country,currentPaymentMethod,vendorData.vendorBanks[0].dfiQualifier)}
                            </div>
                            <div>
                                {vendorData.vendorBanks[0].dfiNumber}
                            </div>
                        </>
                        : <></> 
                        }
                    {(vendorData.vendorBanks[0].ibanId)
                        ? <>
                            <div className="tableHeader">
                                IBAN
                            </div>
                            <div className="bankField">
                                {`${CommonUtils.maskBankString(vendorData.vendorBanks[0].ibanId)}`}
                            </div></>
                        : <></> 
                    }
                    </Col>
                { /* Second Column - Dynamic based on Country */}
                <Col sm={3}>
                    <div className="tableHeader">
                        &nbsp;
                    </div>
                    <div>
                        &nbsp;
                    </div>
                    {
                      (vendorData.vendorBanks[0].bankCode)
                        ? (vendorData.vendorBanks[0].country === "AUS")
                            ? <>
                                <div className="tableHeader">
                                    BSB
                                </div>
                                    <div className="bankField">
                                        {`${vendorData.vendorBanks[0].bankCode} ${vendorData.vendorBanks[0].branchId}`}
                                </div>
                            </>
                            : <>
                                <div className="tableHeader">
                                    {CommonUtils.determineEMEABankIDLabel(vendorData.vendorBanks[0].country)}
                                </div>
                                <div>
                                    {vendorData.vendorBanks[0].bankCode}
                                </div>
                            </>
                        :< ></>
                    }
                    {
                        (vendorData.vendorBanks[0].intermediarySwiftId)
                            ? <>
                                <div className="tableHeader">
                                    Intermediary Swift
                                </div>
                                <div>
                                    {vendorData.vendorBanks[0].intermediarySwiftId}
                                </div>
                            </>
                        : <></>
                     }
                    
                    {
                        (vendorData.vendorBanks[0].country !== "AUS" && vendorData.vendorBanks[0].branchId)
                            ? <>
                                <div className="tableHeader">
                                    Branch ID
                                </div>
                                <div>
                                   { vendorData.vendorBanks[0].branchId}
                                </div>
                            </>
                            : <></>
                    }
                </Col></>
            : <></>;

        
        var vendorDetails = (vendorData) ?
            <>
                <Container className="vendorArea border-left-dark shadow borderCurve" fluid>
                    <Row className="justify-content-md-left">
                        <Col sm={3}>
                            <div className="tableHeader">
                                Supplier Set ID
                            </div>
                            <div>
                                {vendorData.vendorSetId}
                            </div>
                        </Col>
                        <Col sm={3}>
                            <div className="tableHeader">
                                Supplier ID
                            </div>
                            <div>
                                {vendorData.vendorId}
                            </div>
                        </Col>
                        <Col sm={3}>
                            <div className="tableHeader">
                                Supplier Name
                            </div>
                            <div>
                                {vendorData.name}
                            </div>
                        </Col>

                        <Col sm={3}>
                            <div className="tableHeader">
                                Supplier Status
                            </div>
                            <div>
                                {(vendorData.status === 'A') ? 'Active' : 'Inactive'}
                            </div>
                        </Col>
                     
                    </Row>
                    {(showAll) ?
                        <Row className="justify-content-md-left">
                           
                            {(isEMEASupplier)
                                ? <Col sm={3}>&nbsp;</Col>
                                :
                                <Col sm={3}>
                                    <div className="tableHeader">
                                        Payment Currency
                                    </div>
                                    <div>
                                        {CommonUtils.determineVendorCurrencyCode(vendorData)}
                                    </div>
                                </Col>}
                            <Col sm={3}>
                                <div className="tableHeader">
                                    Payment Method
                                </div>
                                <div>
                                    {(vendorData.vendorPayments.length > 0) ? vendorData.vendorPayments[0].paymentMethod : ""}
                                </div>
                            </Col>
                            <Col sm={3}>
                                {(canView) ? <>
                                    <div className="tableHeader">
                                        Payment Terms
                                    </div>
                                    <div>
                                        {(vendorData.vendorPayments.length > 0) ? vendorData.vendorPayments[0].paymentTerms : ""}
                                    </div>
                                </>
                                    : <div>&nbsp;</div>
                                }
                            </Col>
                            <Col sm={3}>
                                <div>&nbsp;</div>
                            </Col>
                        </Row>
                        : <></>}
                    {(canView && showAll) ?
                        <Row className="justify-content-md-left">
                            <Col sm={{ span: 3, offset: 3 }} >
                                <div className="tableHeader">
                                    Commodity Type
                                </div>
                                <div>
                                    {vendorData.commodityType}
                                </div>
                            </Col>
                            <Col sm={3}>
                                <div className="tableHeader">
                                    Persistence
                                </div>
                                <div>
                                    {CommonUtils.determineVendorPersistence(vendorData.persistence)}
                                </div>
                            </Col>
                            <Col sm={3}>
                                <div>&nbsp;</div>
                            </Col>
                        </Row>
                        : <></>
                    }
                </Container>

            </>
            : <Container><Row><Col></Col></Row></Container >;

        var currentBank = (isEMEASupplier)? emeaBankDetails : uhgIdDisplay;
        var paymentDetails = ((showAll && canViewBank) || (canView && showAll) || (canViewRO && showAll))
            ? (isEMEASupplier)
                ? //EMEA Supplier Bank/Payment display
                 <>
                    <Container fluid>
                        <Row className="access-headers">
                            <Col md={2}><h3>Bank Account</h3></Col>
                            <Col md={bankEditSpace}><></></Col>
                            <Col md={bankEditButtonColSpace} className="right">
                                {/* DE774774: Update and Cancel Buttons Active for WIR */}
                                {/* US6815746: Check if there is an approved recent bank request - hasRecentApprovedReqs */}
                                {/* US8665938 - Added vendor bank length check to prevent button from displaying if 0 */ }
                                {(canEditBank && (pendingReqs.length === 0) && (currentPaymentMethod === "ACH" || currentPaymentMethod === "WIR") && (vendorData.vendorBanks.length > 0))
                                    ? (hasRecentApprovedReqs)
                                        ? <div className="approvedBankWarningMsg">Bank account temporarily unavailable for editing</div>
                                        : <>
                                            {/* EMEA Supplier only shows UPDATE Action */}
                                            <VendorBankPopUp editMode="UPDATE" currentCompanyId={this.props.currentCompanyId} currentUser={this.props.currentUser} vendorData={this.props.vendorData} onVendorChange={this.getVendorInfo} />
                                          </>
                                    : <></>
                                }
                            </Col>
                        </Row>
                    </Container>
                    <Container className="vendorArea border-left-dark shadow borderCurve" fluid>
                        {(vendorData.vendorBanks.length === 0)
                            ? (pendingReqs.length === 0)
                                ? <Row><Col> <h4>No Bank</h4></Col></Row>
                                : <Row><Col sm={12}>
                                    {requestMsg}
                                </Col> </Row>
                            : ((currentPaymentMethod === "ACH" || currentPaymentMethod === "WIR") && vendorData.vendorBanks.length > 0)
                                ? (pendingReqs.length === 0)
                                    ? (approvedReqs.length === 0)
                                        ? //Has Bank and no pending requests, no approved
                                        <Row>
                                            <>
                                                {currentBank}
                                                <Col sm={6}>&nbsp;</Col>
                                            </>
                                        </Row>
                                        ://Has Bank and no pending requests, HAS approved
                                        <Row>
                                            {currentBank}   
                                            
                                            <Col sm={3}>
                                                &nbsp;
                                            </Col>
                                        </Row>
                                    : (approvedReqs.length === 0)
                                        ? //Has Bank and pending requests, no approved
                                        <Row>
                                            {currentBank}
                                    
                                            <Col sm={6}>{requestMsg}</Col>
                                        </Row>
                                        ://Has Bank and pending requests and approved
                                        <Row>
                                            {currentBank}   
                                     
                                            <Col sm={3}>{requestMsg}</Col>
                                        </Row>
                                : (pendingReqs.length === 0)
                                    ? //Has NO bank no pending
                                    <Row>
                                        <Col sm={12}>&nbsp;</Col>
                                    </Row>
                                    : //No Bank Has pending 
                                    <Row>
                                        {currentBank}
                          
                                        <Col sm={6}>
                                            {requestMsg}
                                        </Col>
                                    </Row>
                        }

                    </Container>

                </>
                : //UHGID Supplier Bank/Payment display
                <>
                <Container fluid>
                    <Row className="access-headers">
                        <Col md={2}><h3>Bank Account</h3></Col>
                        <Col md={bankEditSpace}><></></Col>
                        <Col md={bankEditButtonColSpace} className="right">
                            {/* DE774774: Update and Cancel Buttons Active for WIR */}
                            {/* US6815746: Check if there is an approved recent bank request - hasRecentApprovedReqs */}
                            {(canEditBank && (pendingReqs.length === 0) && currentPaymentMethod === "ACH")
                                ? (hasRecentApprovedReqs)
                                    ? <div className="approvedBankWarningMsg">Bank account temporarily unavailable for editing</div>
                                    : <>
                                        <VendorBankPopUp editMode="UPDATE" currentCompanyId={this.props.currentCompanyId} currentUser={this.props.currentUser} vendorData={this.props.vendorData} onVendorChange={this.getVendorInfo} />
                                        <VendorBankPopUp editMode="CANCEL" currentCompanyId={this.props.currentCompanyId} currentUser={this.props.currentUser} vendorData={this.props.vendorData} onVendorChange={this.getVendorInfo} />
                                    </>
                                : <></>
                            }
                        </Col>
                    </Row>
                </Container>
                <Container className="vendorArea border-left-dark shadow borderCurve" fluid>
                    {(vendorData.vendorBanks.length === 0)
                        ? (pendingReqs.length === 0)
                            ? <Row><Col> <h4>No Bank</h4></Col></Row>
                            : <Row><Col sm={12}>
                                {requestMsg}
                            </Col> </Row>
                        : ((currentPaymentMethod === "ACH" || currentPaymentMethod === "WIR") && vendorData.vendorBanks.length > 0)
                            ? (pendingReqs.length === 0)
                                ? (approvedReqs.length === 0)
                                    ? //Has Bank and no pending requests, no approved
                                    <Row>
                                        <>
                                            {currentBank}
                                            <Col sm={9}>&nbsp;</Col>
                                        </>
                                    </Row>
                                    ://Has Bank and no pending requests, HAS approved
                                    <Row>
                                        {currentBank}
                                        {this.formatAddress()}
                                        <Col sm={6}>
                                            &nbsp;
                                        </Col>
                                    </Row>
                                : (approvedReqs.length === 0)
                                    ? //Has Bank and pending requests, no approved
                                    <Row>
                                        {currentBank}
                                        <Col sm={9}>{requestMsg}</Col>
                                    </Row>
                                    ://Has Bank and pending requests and approved
                                    <Row>
                                        {currentBank}
                                        {this.formatAddress()}
                                        <Col sm={6}>{requestMsg}</Col>
                                    </Row>
                            : (pendingReqs.length === 0)
                                ? //Has NO bank no pending
                                <Row>
                                    <Col sm={12}>&nbsp;</Col>
                                </Row>
                                : //No Bank Has pending 
                                <Row>
                                    {currentBank}
                                    <Col sm={9}>
                                        {requestMsg}
                                    </Col>
                                </Row>
                    }

                </Container>

            </>
            : <></>;


        return (
            (isEMEASupplier)
                ? //NON-UHGID SUPPLIER
                <>
                    <Container fluid>
                        <Row className="access-headers">
                            <Col md={2}><h3>{this.props.title}</h3></Col>
                            {(this.props.returnUrl)
                                ? <Col md={10}><h5 className="addressLink">{this.props.returnUrl}</h5></Col>
                                : <></>
                            }
                        </Row>
                    </Container>

                    {vendorDetails}
                    {paymentDetails}
                </>

                ://UHGID SUPPLIER
                <>
            <Container fluid>
                <Row className="access-headers">
                    <Col md={2}><h3>{this.props.title}</h3></Col>
                    {(this.props.returnUrl)
                        ? <Col md={10}><h5 className="addressLink">{this.props.returnUrl}</h5></Col>
                        : (showAddBank)
                            ?
                            <>
                                <Col md={ bankEditSpace }><></></Col>
                                <Col md={bankEditButtonColSpace}>
                                    {(canEditBank)
                                        ? (hasRecentApprovedReqs)
                                            ? <div className="approvedBankWarningMsg">Bank account temporarily unavailable for editing</div>
                                            : <VendorBankPopUp editMode="ADD" currentCompanyId={this.props.currentCompanyId} currentUser={this.props.currentUser} vendorData={this.props.vendorData} onVendorChange={this.getVendorInfo} />
                                        : <></>
                                    }
                                </Col>
                            </>
                            : <></>
                    }
                </Row>
            </Container>

            {vendorDetails}
            {paymentDetails}
        </>);
    }

    render() {
        var display = (this.state.isLoading)
            ? <div style={{ margin: "auto", width: "200px" }}>
                <Loading />
            </div>
            : this.buildTable();

        return (
            <>
                {display}
            </>
        )
    }
}
